import { IndicationModel } from "./indication-model"

export class GetProcLinkModel {
    intCodeNo: number
    intCodeType     : number 
    strCodeName: string
    LinkInfo: LinkRecordModel[]
    intLinkCount: number
    intLinkCatCount: number
    lngPetNo: number
    intClinicNo: number
    intLinkIndicationID: number
    strStatus: string

    constructor(
        intCodeNo: number,
        intCodeType: number,
        strCodeName: string,
        LinkInfo: LinkRecordModel[],
        intLinkCount: number,
        intLinkCatCount: number,
        lngPetNo: number,
        intClinicNo: number,
        intLinkIndicationID: number,
        strStatus: string
    ) {
        this.intCodeNo = intCodeNo
        this.intCodeType = intCodeType
        this.strCodeName = strCodeName
        this.LinkInfo = LinkInfo
        this.intLinkCount = intLinkCount
        this.intLinkCatCount = intLinkCatCount
        this.lngPetNo = lngPetNo
        this.intClinicNo = intClinicNo
        this.intLinkIndicationID = intLinkIndicationID
        this.strStatus = strStatus
    }
}

export class LinkRecordModel {
    ProcNo: number
    Seq: number
    LinkNo: number
    SelectedLinkName?: string
    LinkType: number
    code: string
    Desc: string
    Category: string
    MinWeight: number
    MaxWeight: number
    MinAge: number
    MaxAge: number
    Specie: number
    Sex: string
    ChkPrice: string
    Price: number
    SalePrice: number
    BaseCharge: string
    AddPrice: number
    Freq: string
    RecFix: string
    Dosage: number
    Qty : number
    Variant: number
    SubHist: number
    Printable: boolean
    SaleTreat: string
    Active: string
    CodeCategory: string
    CodeSubCategory: string
    LinkName?: string
    LinkID?: number
    SelectedLinkID?: number
    RescuePrice: string
    AltDays: number
    MinDose : number
    MaxDose : number
    IndicationID : number
    Notes :string
    Days : number
    AdminRoute : string 
    DosageUnit:string
    Location: string
    Dose: string
    MinDosage : number
    MaxDosage : number
    item_strength: number
    smallest_unit: number
    PetWeight: number
    Visible: Boolean 
    Children: LinkRecordModel[]
    SelectedArr: string[] = []
    Indications: IndicationModel []  
    Expanded: Boolean 
    ParentNo: number
    NonProfit: boolean
    NodeNo: number
    Status: string
    Reason: string
    constructor(
        ProcNo: number,
        Seq: number,
        LinkNo: number,
        LinkType: number,
        code: string,
        Desc: string,
        Category: string,
        MinWeight: number,
        MaxWeight: number,
        MinAge: number,
        MaxAge: number,
        Specie: number,
        Sex: string,
        ChkPrice: string,
        Price: number,
        SalePrice: number,
        BaseCharge: string,
        AddPrice: number,
        Freq: string,
        RecFix: string,
        Dosage: number,
        Qty : number,
        Variant: number,
        SubHist: number,
        Printable: boolean,
        SaleTreat: string,
        Active: string,
        CodeCategory: string,
        CodeSubCategory: string,
        RescuePrice: string,
        AltDays: number,
        MinDose : number,
        MaxDose : number,
        IndicationID : number,
        Notes :string,
        Days : number,
        AdminRoute : string,    
        DosageUnit:string,
        Location: string, 
        Dose: string,
        MinDosage : number,
        MaxDosage : number ,
        item_strength: number, 
        smallest_unit: number,
        PetWeight: number,
        Visible: Boolean ,
        Children: LinkRecordModel[],
        SelectedArr: string[],
        Expanded: Boolean ,
        Indications: IndicationModel [],
        ParentNo: number,
        NonProfit: boolean,
        NodeNo: number,
        Status: string,
        Reason: string
    ) {
        this.ProcNo = ProcNo
        this.Seq = Seq
        this.LinkNo = LinkNo
        this.LinkType = LinkType
        this.code = code
        this.Desc = Desc
        this.Category = Category
        this.MinWeight = MinWeight
        this.MaxWeight = MaxWeight
        this.MinAge = MinAge
        this.MaxAge = MaxAge
        this.Specie = Specie
        this.Sex = Sex
        this.ChkPrice = ChkPrice
        this.Price = Price
        this.SalePrice = SalePrice
        this.BaseCharge = BaseCharge
        this.AddPrice = AddPrice
        this.Freq = Freq
        this.RecFix = RecFix
        this.Dosage = Dosage
        this.Qty = Qty
        this.Variant = Variant
        this.SubHist = SubHist
        this.Printable = Printable
        this.SaleTreat = SaleTreat
        this.Active = Active
        this.CodeCategory = CodeCategory
        this.CodeSubCategory = CodeSubCategory
        this.RescuePrice =RescuePrice
        this.AltDays = AltDays
        this.MinDose = MinDose
        this.MaxDose = MaxDose
        this.item_strength = item_strength
        this.smallest_unit = smallest_unit
        this.IndicationID = IndicationID
        this.Notes = Notes
        this.Days = Days
        this.AdminRoute = AdminRoute
        this.DosageUnit = DosageUnit
        this.Location = Location
        this.Dose = Dose
        this.MinDosage = MinDosage  
        this.MaxDosage = MaxDosage
        this.Visible = Visible
        this.Expanded =  Expanded 
        this.Children = Children
        this.SelectedArr = SelectedArr
        this.Indications = Indications
        this.PetWeight = PetWeight
        this.ParentNo = ParentNo
        this.NodeNo = NodeNo
        this.Status = Status
        this.Reason = Reason
        this.NonProfit = NonProfit
    }
}